module.exports = __webpack_public_path__ + "static/media/supplier-collage-desktop.7fb8ea7c.webp";